import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Badge from "@material-ui/core/Badge";

import ProjectCard from "../../components/ProjectCards/ProjectCard";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";

const userRole = localStorage.getItem("userRole");

function TabContainer(props) {
  return (
    <Typography component="div" style={{ paddingTop: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};
const styles = (theme) => ({
  mainWrapper: {
    marginTop: 20,
  },
  root: {
    flexGrow: 1,
    backgroundColor: "#fafafa",
    boxShadow: "none",
  },
  indicator: {
    backgroundColor: "#00aeef",
  },
  selected: {
    color: "#606060",
    outline: "none",
    "&:hover": {
      color: "#40a9ff",
      opacity: 1,
    },

    "&:focus": {
      outline: "none",
      color: "#40a9ff",
    },
  },
  badgeContainer: {
    padding: `0 ${theme.spacing.unit * 2}px`,
    fontSize: 14,
    color: "#606060",
    fontWeight: 500,
  },
});

class TabComponent extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { classes, jobData } = this.props;
    const { value } = this.state;
    const numofOpen =
      jobData &&
      jobData.filter(
        (data) => data.job_status === "Posted" || data.job_status === "Created"
      ).length;
    const numofInprogress =
      jobData &&
      jobData.filter((data) => data.job_status === "In-progress").length;
    const numofVerify =
      jobData && jobData.filter((data) => data.job_status === "Verify").length;
    const numofCompleted =
      jobData &&
      jobData.filter((data) => data.job_status === "Completed").length;
    return (
      <div className={classes.mainWrapper}>
        {userRole === "Surveyor" ? (
          <AppBar position="static" className={classes.root}>
            <Tabs
              scrollButtons="auto"
              variant="scrollable"
              classes={{ indicator: classes.indicator }}
              value={value}
              onChange={this.handleChange}
            >
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofOpen}
                  >
                    Opportunities
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofInprogress}
                  >
                    Job in progress
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofVerify}
                  >
                    Job submitted
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofCompleted}
                  >
                    Job completed
                  </Badge>
                }
                className={classes.selected}
              />
            </Tabs>
          </AppBar>
        ) : userRole === "Title Company Admin" ||
          userRole === "Title Company User" ? (
          <AppBar position="static" className={classes.root}>
            <Tabs
              classes={{ indicator: classes.indicator }}
              value={value}
              onChange={this.handleChange}
            >
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofOpen}
                  >
                    Open jobs
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofInprogress}
                  >
                    Job in progress
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofVerify}
                  >
                    Job submitted
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofCompleted}
                  >
                    Job completed
                  </Badge>
                }
                className={classes.selected}
              />
            </Tabs>
          </AppBar>
        ) : userRole === "Admin" ? (
          <AppBar position="static" className={classes.root}>
            <Tabs
              classes={{ indicator: classes.indicator }}
              value={value}
              onChange={this.handleChange}
            >
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofOpen}
                  >
                    Open jobs
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofInprogress}
                  >
                    Job in progress
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofVerify}
                  >
                    Job submitted
                  </Badge>
                }
                className={classes.selected}
              />
              <Tab
                label={
                  <Badge
                    className={classes.badgeContainer}
                    color="primary"
                    badgeContent={numofCompleted}
                  >
                    Job completed
                  </Badge>
                }
                className={classes.selected}
              />
            </Tabs>
          </AppBar>
        ) : null}

        {value === 0 && (
          <TabContainer className={classes.tabContainer}>
            {jobData &&
              jobData
                .filter(
                  (jobData) =>
                    jobData.job_status === "Posted" ||
                    jobData.job_status === "Created" ||
                    jobData.job_status === "Expired"
                )
                .map((job) => {
                  return <ProjectCard key={job.id} jobData={job} />;
                })}
          </TabContainer>
        )}
        {value === 1 && (
          <TabContainer className={classes.tabContainer}>
            {jobData &&
              jobData
                .filter((jobData) => jobData.job_status === "In-progress")
                .map((job) => {
                  return <ProjectCard key={job.id} jobData={job} />;
                })}
          </TabContainer>
        )}
        {value === 2 && (
          <TabContainer className={classes.tabContainer}>
            {jobData &&
              jobData
                .filter((jobData) => jobData.job_status === "Verify")
                .map((job) => {
                  return <ProjectCard key={job.id} jobData={job} />;
                })}
          </TabContainer>
        )}

        {value === 3 && (
          <TabContainer className={classes.tabContainer}>
            {jobData &&
              jobData
                .filter((jobData) => jobData.job_status === "Completed")
                .map((job) => {
                  return <ProjectCard key={job.id} jobData={job} />;
                })}
          </TabContainer>
        )}
      </div>
    );
  }
}

TabComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TabComponent);



// WEBPACK FOOTER //
// ./src/pages/Dashboard/Tab.js